
export function setupTooltips() {
  document.querySelectorAll('[title]').forEach(el => {
    const title = el.getAttribute('title');
    el.removeAttribute('title');

    const tooltip = document.createElement('div');
    tooltip.textContent = title;
    tooltip.className = 'absolute bg-black text-white text-sm p-2 rounded z-[100] transition-opacity duration-200 ease-in-out max-w-md';
    tooltip.style.display = 'none';
    tooltip.style.opacity = "0";
    document.body.appendChild(tooltip);

    el.addEventListener('mouseenter', () => {
      const rect = el.getBoundingClientRect();
      const pageWidth = window.innerWidth;
      const pageHeight = window.innerHeight;
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;

      const isLeft = rect.left <= pageWidth * 0.25;
      const isRight = rect.right >= pageWidth * 0.75;
      const isBottomHalf = rect.top >= pageHeight / 2;
      const isTopHalf = rect.top < pageHeight / 2;
      const isHorizontallyCentered = rect.left > pageWidth * 0.25 && rect.right < pageWidth * 0.75;

      let top, left;

      let paddingX = 12;
      if (isLeft) {
        top = scrollY + rect.top + rect.height / 2 - tooltip.offsetHeight / 2;
        left = scrollX + rect.right + paddingX;
      } else if (isRight) {
        top = scrollY + rect.top + rect.height / 2 - tooltip.offsetHeight / 2;
        left = scrollX + rect.left - tooltip.offsetWidth - paddingX;
      } else if (isBottomHalf && isHorizontallyCentered) {
        top = scrollY + rect.top - tooltip.offsetHeight - paddingX;
        left = scrollX + rect.left + rect.width / 2 - tooltip.offsetWidth / 2;
      } else {
        top = scrollY + rect.bottom + paddingX;
        left = scrollX + rect.left + rect.width / 2 - tooltip.offsetWidth / 2;
      }

      tooltip.style.top = `${top}px`;
      tooltip.style.left = `${left}px`;
      tooltip.style.visibility = 'visible';
      tooltip.style.display = 'block';
      tooltip.style.opacity = "1";
    });

    el.addEventListener('mouseleave', () => {
      tooltip.style.visibility = 'hidden';
      tooltip.style.opacity = "0";
    });
  });
}

